import { render, staticRenderFns } from "./TypeOfGarbage.vue?vue&type=template&id=3204ed80"
import script from "./TypeOfGarbage.vue?vue&type=script&lang=js"
export * from "./TypeOfGarbage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports